import { Container, Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { CustomerList } from '../../../../components/lists/customers-list';
import { RootState } from '../../../../store';


// title is the title of the page
const title = "POM - Customers"
// heading is the info header
const heading = "Customers"

export const CustomerListScreen: React.FC = () => {
    const navigate = useNavigate();
    const { authUser } = useSelector((state: RootState) => state.auth);

    return (
        <Page title={title}>
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading={heading}
                        links={[
                            {
                                name:  authUser ? 'Listing all the customers on POM.' :' Your subscripition customers list.',
                                href: '/customers'
                            },
                        ]}
                        activeLast={false}
                    />
                    <Button 
                        variant="contained"
                        onClick={() => navigate('/customers/create')}
                    >
                        Add new customer
                    </Button>
    
                </Stack>
                <CustomerList />
            </Container>
        </Page>
    )
}